<script setup>
  import { getCurrentInstance, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { storeToRefs } from "pinia";
  import { useUserStore } from '../../stores/user';
  import { useNavigationStore } from '../../../../stores/navigation';
  import JobFairReusmeCreatePolicyModal from '../../components/modal/jobFair/JobFairReusmeCreatePolicyModal.vue';
import mypageJobFairService from '../../services/mypage/jobFair/mypageJobFairService';

  const route = useRoute()
  const router = useRouter()
  const navigationStore = useNavigationStore()
  
  localStorage.setItem('isModalVisible', 'false');

  const userStore = useUserStore()
  const { user, isAuthenticated } = storeToRefs(userStore);

  const { alert } = getCurrentInstance().appContext.config.globalProperties;

  const jobFairReusmeCreatePolicyModal = ref(null);

  const loaded = ref(false);

  const onClickResumeCreate = async () => {
    if(!isAuthenticated.value) {
      alert("로그인 후 이용해주세요.");
      navigationStore.lastAccessPage = route.fullPath;
      router.push({name: 'Signin'});
    } else {
      if (user.value.userGb === 'STUDENT') {
        const userId = user.value.userInfo.userCd;

        // 학생 이력서 등록시 정보제공동의여부 확인
        mypageJobFairService.retrieveRecruitPrivacyAgreeYnByUserId(userId)
          .then( async (res) => {
            loaded.value = true;
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;

              if (result !== 'Y') { // 개인정보 이용 동의 내역이 없을때
                const ok = await jobFairReusmeCreatePolicyModal.value.show();
                if(ok) {
                  router.push({ name: 'MyPageJobFairResumeCreate'});
                }
              } else {
                router.push({ name: 'MyPageJobFairResumeCreate' });
              }
            }
          })
          .catch( (error) =>  {
            loaded.value = true;
          });
      } else {
        alert(["학생/취업준비생 회원만", "인재정보 이력서 등록이 가능합니다."]);
      }
    }
  }

  const onClickJobPostingCreate = () => {
    if(!isAuthenticated.value) {
      alert("로그인 후 이용해주세요.");
      navigationStore.lastAccessPage = route.fullPath;
      router.push({name: 'Signin'});
    } else {
      if ((user.value.userGb === 'COMPANY' && user.value.userInfo?.corpMasterYn === 'Y')) {
        const corpId = user.value.userInfo.corporation.corpId;

        // 기업 채용공고 등록 시 기업정보 등록 및 정보제공동의여부 확인
        mypageJobFairService.retrieveRecruitPrivacyAgreeYnByCorpId(corpId)
          .then( async (res) => {
            loaded.value = true;
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;

              if (result !== 'Y') {  // 기업정보 및 정보제공동의여부 내역 없을 때
                const ok = await alert(["등록된 기업정보가 없습니다.", "기업정보 등록 후 채용공고 등록이 가능합니다."]);
                if(ok) {
                  router.push({ name: 'MyPageCorpInfoCreate' });
                }
              } else {
                router.push({ name: 'MyPageCorpJobNoticeCreate' });
              }
            }
          })
          .catch( (error) =>  {
            loaded.value = true;
          });
      } else {
        alert(["재직자/기업 마스터 회원만", "채용공고 등록이 가능합니다."]);
      }
    }
  }

  const onClickTabView = (tab) => {
    router.push({ name: 'MatchingJob', query: { tab: tab } });
  }
</script>

<template>
  <div>
    <div class="info-container" >
      <!-- <h4>KSA 채용지원시스템</h4> -->
      <div class="info-container-detail">
        <ul>
          <li>- 구직자와 기업간 입사 지원과 채용 제안이 <strong><em>실시간으로 이루어지는 양방향 채용지원시스템</em></strong>입니다.</li>
          <li>- 학생/취업준비생 회원은 한국디스플레이아카데미 채용지원시스템을 통해 관심 분야 기업군 대상 <strong><em>입사 지원</em></strong>이 가능합니다.</li>
          <li>- 재직자/기업(인사담당자) 회원은 채용지원시스템을 통해 채용 직무를 관심 카테고리로 등록한 미취업자 대상 <strong><em>채용 제안</em></strong>이 가능합니다.</li>
        </ul>
      </div>
    </div>
    <div class="btn-wrap">
      <div class="btn-box student">
        <img src="/src/assets/images/job_student_bg.png" />
        <div class="btn">
          <button @click="onClickResumeCreate()">이력서 등록하기</button>
          <button @click="onClickTabView('job-postings')">채용공고 확인하기</button>
        </div>
      </div>
      <div class="btn-box company">
        <img src="/src/assets/images/job_company_bg.png" />
        <div class="btn">
          <button @click="onClickJobPostingCreate()">채용공고 등록하기</button>
          <button @click="onClickTabView('talent')">인재정보 검색하기</button>
        </div>
      </div>
    </div>
    <!--div class="image-full-width-container">
      <img src="/src/assets/images/kda-hire-process.png" alt="실시간 양방향 채용지원시스템" class="image-full-width"/>
    </div-->
  </div>
  <JobFairReusmeCreatePolicyModal ref="jobFairReusmeCreatePolicyModal" />
</template>

<style lang="scss" scoped>
@import "../../../../assets/scss/theme";

.container .inner img { width: 100%; }

.btn-wrap {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  .btn-box {
    position: relative;
    width: 600px;
    margin: 20px;
    &.company {
      .btn {
        button {
          background: #0341a0;
          box-shadow:
            inset 0 2px 0 rgba(255, 255, 255, 0.18),
            inset 0 -4px 0 rgba(0, 0, 0, 0.18),
            0 4px 0 #062a63;
        }
      }
    }
    .btn {
      position: absolute;
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;
      bottom: 74px;
      img {
        width: 70% !important;
      }
      button {
        width: 70%;
        height: 64px;
        display: block;
        margin: auto;
        border-radius: 20px;
        cursor: pointer;
        border: none;

        /* 배경 */
        background: #01a9ec;

        /* 글자 */
        color: #ffffff;
        font-size: 30px;
        font-weight: 700;
        text-align: center;

        /* 입체감 */
        box-shadow:
          inset 0 2px 0 rgba(255, 255, 255, 0.35),
          inset 0 -4px 0 rgba(0, 0, 0, 0.08),
          0 4px 0 #118ed1;

        /* 텍스트 그림자 */
        text-shadow: 0 2px 0 rgba(0, 0, 0, 0.12);
      }
    }
  }
}

.image-full-width-container{
  position: relative;
  background-color:#e8f5fd;
  text-align: center;
  padding:0;
  margin:0;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    height: 100%;
    background-color:#e8f5fd;
  }
  .image-full-width{
    height:500px;
    position:relative;
    bottom:-5px;
  }
}
</style>